
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "data-privacy-request-ui",
  currentProjectVersion: "static-1.6031",
  depVersions: {
  "data-privacy-request-ui": "static-1.6031",
  "client-types": "static-1.512",
  "data-fetching-client": "static-1.10142",
  "head-dlb": "static-1.5330",
  "hs-test-utils": "static-1.8544",
  "hub-http-shared-msw-handlers": "static-1.10950",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11992",
  "I18n": "static-7.1715",
  "jasmine-runner": "static-1.6957",
  "quartz": "static-1.7694",
  "react-dlb": "static-1.96",
  "rpc-client-utils": "static-1.5170",
  "ui-components-test-utils": "static-1.6129",
  "UIComponents": "static-3.8938",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.101",
  "foundations-assets": "static-1.5394",
  "foundations-components": "static-1.8794",
  "foundations-components-test-utils": "static-1.6277",
  "foundations-theming": "static-1.4994",
  "hub-http": "static-1.6710",
  "hubspot-url-utils": "static-1.4383",
  "quartz-config": "static-1.1472",
  "quartz-core": "static-1.6913",
  "quartz-routing": "static-1.1124",
  "quartz-tracking": "static-1.1073",
  "quick-fetch": "static-1.4245",
  "raven": "static-3.6411",
  "react": "static-7.204",
  "react-rhumb": "static-1.17243",
  "SharedI18nStrings": "static-1.190",
  "ui-addon-i18n": "static-1.11650",
  "usage-tracker-core": "static-1.7676",
  "enviro": "static-4.523",
  "hs-promise-rejection-tracking": "static-1.6078",
  "PortalIdParser": "static-2.458",
  "raven-hubspot": "static-1.6718",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3971",
  "quartz-webpack": "static-1.3918",
  "bend-plugin-quartz-routing": "static-1.772",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.95",
  "HeadJS": "static-2.829",
  "framer-motion": "static-1.86",
  "hs-test-utils-bend-plugin": "static-1.3655",
  "msw": "static-1.105",
  "msw-config": "static-1.35",
  "testing-library": "static-1.167",
  "ts-schema": "static-1.4409",
  "i18n-data": "static-1.237",
  "moment-timezone": "static-5.98",
  "react-utils": "static-2.5682",
  "StyleGuideUI": "static-3.520",
  "jasmine": "static-4.4810",
  "bend-plugin-chirp-manifest": "static-1.580",
  "chirp-fetch": "static-1.2409",
  "HubStyle": "static-2.12299",
  "ui-addon-draggable": "static-3.5256",
  "cssUtils": "static-1.1126",
  "hs-story-utils": "static-1.9932",
  "icons": "static-2.709",
  "react-create-root-preference": "static-1.111",
  "react-select-plus": "static-1.120",
  "react-virtualized": "static-2.114",
  "ui-images": "static-2.1283",
  "bend-plugin-foundations-components": "static-1.5063",
  "floating-ui": "static-1.70",
  "foundations-theming-specialty": "static-1.2710",
  "react-aria": "static-1.79",
  "tanstack-table": "static-1.68",
  "trellis-assets": "static-1.3162",
  "ui-fonts": "static-1.1254",
  "foundations-components-legacy": "static-1.1819",
  "bend-plugin-foundations-theming": "static-1.3477",
  "foundations-theming-base": "static-1.3979",
  "stylex": "static-1.48",
  "hs-locale-management": "static-1.416",
  "opentelemetry-fe-types": "static-1.297",
  "dispatcher": "static-1.150",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.913",
  "hubspotter-http": "static-1.4989",
  "mobile-manifest-mixins": "static-1.612",
  "module-federation": "static-1.42",
  "opentelemetry-fe": "static-1.672",
  "quartz-auth": "static-1.1369",
  "quartz-head": "static-1.1359",
  "quartz-i18n": "static-1.1369",
  "quartz-test": "static-1.1369",
  "trellis-components": "static-1.3181",
  "usage-tracker-container": "static-1.7816",
  "usage-tracker-session-replay": "static-1.5512",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.204",
  "web-vitals": "static-1.21",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3617",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.85",
  "sassPrefix": "static-1.391",
  "stylex-utils": "static-1.182",
  "trellis-theming": "static-1.1521",
  "opentelemetry-web": "static-1.25",
  "hubspotter-http-shared-msw-handlers": "static-1.10948",
  "base-ui": "static-1.31",
  "react-day-picker": "static-1.17",
  "tanstack-virtual": "static-1.45",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.6031",
  "client-types": "/client-types/static-1.512",
  "data-fetching-client": "/data-fetching-client/static-1.10142",
  "head-dlb": "/head-dlb/static-1.5330",
  "hs-test-utils": "/hs-test-utils/static-1.8544",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10950",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11992",
  "I18n": "/I18n/static-7.1715",
  "jasmine-runner": "/jasmine-runner/static-1.6957",
  "quartz": "/quartz/static-1.7694",
  "react-dlb": "/react-dlb/static-1.96",
  "rpc-client-utils": "/rpc-client-utils/static-1.5170",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6129",
  "UIComponents": "/UIComponents/static-3.8938",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.101",
  "foundations-assets": "/foundations-assets/static-1.5394",
  "foundations-components": "/foundations-components/static-1.8794",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6277",
  "foundations-theming": "/foundations-theming/static-1.4994",
  "hub-http": "/hub-http/static-1.6710",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "quartz-config": "/quartz-config/static-1.1472",
  "quartz-core": "/quartz-core/static-1.6913",
  "quartz-routing": "/quartz-routing/static-1.1124",
  "quartz-tracking": "/quartz-tracking/static-1.1073",
  "quick-fetch": "/quick-fetch/static-1.4245",
  "raven": "/raven/static-3.6411",
  "react": "/react/static-7.204",
  "react-rhumb": "/react-rhumb/static-1.17243",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.190",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11650",
  "usage-tracker-core": "/usage-tracker-core/static-1.7676",
  "enviro": "/enviro/static-4.523",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6078",
  "PortalIdParser": "/PortalIdParser/static-2.458",
  "raven-hubspot": "/raven-hubspot/static-1.6718",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3971",
  "quartz-webpack": "/quartz-webpack/static-1.3918",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.772",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.95",
  "HeadJS": "/HeadJS/static-2.829",
  "framer-motion": "/framer-motion/static-1.86",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3655",
  "msw": "/msw/static-1.105",
  "msw-config": "/msw-config/static-1.35",
  "testing-library": "/testing-library/static-1.167",
  "ts-schema": "/ts-schema/static-1.4409",
  "i18n-data": "/i18n-data/static-1.237",
  "moment-timezone": "/moment-timezone/static-5.98",
  "react-utils": "/react-utils/static-2.5682",
  "StyleGuideUI": "/StyleGuideUI/static-3.520",
  "jasmine": "/jasmine/static-4.4810",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.580",
  "chirp-fetch": "/chirp-fetch/static-1.2409",
  "HubStyle": "/HubStyle/static-2.12299",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5256",
  "cssUtils": "/cssUtils/static-1.1126",
  "hs-story-utils": "/hs-story-utils/static-1.9932",
  "icons": "/icons/static-2.709",
  "react-create-root-preference": "/react-create-root-preference/static-1.111",
  "react-select-plus": "/react-select-plus/static-1.120",
  "react-virtualized": "/react-virtualized/static-2.114",
  "ui-images": "/ui-images/static-2.1283",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5063",
  "floating-ui": "/floating-ui/static-1.70",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2710",
  "react-aria": "/react-aria/static-1.79",
  "tanstack-table": "/tanstack-table/static-1.68",
  "trellis-assets": "/trellis-assets/static-1.3162",
  "ui-fonts": "/ui-fonts/static-1.1254",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1819",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3477",
  "foundations-theming-base": "/foundations-theming-base/static-1.3979",
  "stylex": "/stylex/static-1.48",
  "hs-locale-management": "/hs-locale-management/static-1.416",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.297",
  "dispatcher": "/dispatcher/static-1.150",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.913",
  "hubspotter-http": "/hubspotter-http/static-1.4989",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.612",
  "module-federation": "/module-federation/static-1.42",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.672",
  "quartz-auth": "/quartz-auth/static-1.1369",
  "quartz-head": "/quartz-head/static-1.1359",
  "quartz-i18n": "/quartz-i18n/static-1.1369",
  "quartz-test": "/quartz-test/static-1.1369",
  "trellis-components": "/trellis-components/static-1.3181",
  "usage-tracker-container": "/usage-tracker-container/static-1.7816",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5512",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.204",
  "web-vitals": "/web-vitals/static-1.21",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3617",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.85",
  "sassPrefix": "/sassPrefix/static-1.391",
  "stylex-utils": "/stylex-utils/static-1.182",
  "trellis-theming": "/trellis-theming/static-1.1521",
  "opentelemetry-web": "/opentelemetry-web/static-1.25",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10948",
  "base-ui": "/base-ui/static-1.31",
  "react-day-picker": "/react-day-picker/static-1.17",
  "tanstack-virtual": "/tanstack-virtual/static-1.45",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
